<template>
  <div
    id="navigation"
    class="navigation"
    :class="{ 'navigation__subsection--open': $route.params.subsectionSlug }"
    v-sticky
  >
    <div class="container navigation__header">
      <router-link
        :to="{ name: 'section', params: { sectionSlug: home.slug } }"
        @click.native="scrollTop"
      >
        <img class="logo" src="/images/lfc-logo.svg" alt="" />
      </router-link>
      <p class="navigation__section-name" v-if="$route.params.subsectionSlug">
        {{ section.title }}
      </p>
      <div>
        <ul
          class="socials desktop"
          v-if="socials && socials.fields.active_socials.value == 1"
        >
          <li
            v-for="social in socials.fields"
            v-if="social.value.length && social.name != 'active_socials'"
            :key="social.id"
          >
            <a :href="social.value" target="_blank">
              <img
                :src="'/images/' + social.name + '.svg'"
                :alt="social.name"
              />
            </a>
          </li>
        </ul>
        <div class="navigation__burger" @click="menu = !menu">
          <div></div>
          <div :class="{ active: menu }"></div>
          <div></div>
        </div>
      </div>
    </div>

    <!-- Navigation body -->
    <transition name="fade">
      <div class="navigation__body" v-if="menu">
        <div class="container" :class="{ active: selectedList !== null }">
          <ul class="main-list" :class="{ 'no-border': selectedList }">
            <li
              v-for="(sc, index) in navItems(sections)"
              :key="sc.id"
              :class="{
                active:
                  index == selectedList ||
                  (sc.type == section.type && selectedList == null),
                'active-mobile': index != selectedList,
                'not-active': selectedList != null && index != selectedList,
              }"
            >
              <p @click="getSubmenu(sc, index)">
                <span>0{{ sc.index }}.</span>
                <template v-if="sc.type !== 'documents'">
                  {{ sc.title }}
                </template>
                <router-link
                  v-else
                  :to="{
                    name: 'SubSection',
                    params: {
                      sectionSlug: sc.parentSlug,
                      subsectionSlug: sc.slug,
                    },
                  }"
                >
                  {{ sc.title }}
                </router-link>
                <img
                  class="d-sm-none cross"
                  src="/images/plus.svg"
                  alt="more"
                />
              </p>
            </li>
          </ul>
          <ul class="submenu-list" v-if="submenu">
            <template v-if="submenu.type == 'teams'">
              <li
                v-for="team in teams"
                :key="team.id"
                class="gsap-fade"
                v-if="team.show_on_nav == 1"
              >
                <a @click.prevent="goToTeam(team)">
                  {{ team.name }}
                </a>
              </li>

              <li
                v-for="teamCategory in teamsWithCategories"
                :key="teamCategory.id"
                class="gsap-fade"
                v-if="
                  teamCategory.type &&
                    (teamCategory.type == 'actifs' ||
                      teamCategory.type == 'juniors' ||
                      teamCategory.type == 'futsal' ||
                      teamCategory.type == 'females')
                "
              >
                <router-link
                  :to="{
                    name: 'SubSection',
                    params: {
                      sectionSlug: submenu.slug,
                      subsectionSlug: teamCategory.slug,
                    },
                  }"
                >
                  {{ teamCategory.name }}
                </router-link>
              </li>
            </template>
            <template v-else>
              <li
                v-for="list in submenu.children"
                :key="list.id"
                class="gsap-fade"
                v-if="list.type !== 'documents'"
              >
                <router-link
                  :to="{
                    name: 'SubSection',
                    params: {
                      sectionSlug: submenu.slug,
                      subsectionSlug: list.slug,
                    },
                  }"
                  :class="{ active: list.slug == $route.params.subsectionSlug }"
                >
                  {{ list.title }}
                </router-link>
              </li>
            </template>
          </ul>
        </div>
        <!-- Socials on mobile -->
        <ul
          class="socials mobile"
          v-if="socials && socials.fields.active_socials.value == 1"
        >
          <li
            v-for="social in socials.fields"
            v-if="social.value.length && social.name != 'active_socials'"
            :key="social.id"
          >
            <a :href="social.value">
              <img
                :src="'/images/' + social.name + '.svg'"
                :alt="social.name"
              />
            </a>
          </li>
        </ul>
      </div>
    </transition>

    <!-- SubSections list-->
    <div
      v-sub-menu-animate
      :class="[
        'subsections-list',
        { 'subsections-list--active': subsectionsOpen || teamsNavOpen },
      ]"
    >
      <ul
        v-if="
          (team && team.show_on_nav == 0) ||
            juniorsLastSubCategory ||
            playerInfoOpen ||
            (section.type == 'news' && $route.params.pageSlug)
        "
      >
        <li>
          <a
            v-if="juniorsLastSubCategory"
            @click.prevent="
              $root.juniorsSubCategory = null;
              $root.documentsOpen = false;
            "
            class="player-go-back"
          >
            <img src="/images/arrow-left-white.svg" alt="" />
            RETOUR
          </a>
          <router-link
            :to="{
              name: 'SubSection',
              params: {
                sectionSlug: section.slug,
                subsectionSlug: $route.params.subsectionSlug,
              },
            }"
            v-else-if="team && team.show_on_nav == 0"
            class="player-go-back"
          >
            <img src="/images/arrow-left-white.svg" alt="" />
            {{ team.name }}
          </router-link>
          <router-link
            :to="{
              name: 'SubSection',
              params: {
                sectionSlug: section.slug,
                subsectionSlug: section.children[0].slug,
              },
            }"
            v-else-if="section.type == 'news'"
            @click.prevent="$root.playerInfoOpen = false"
            class="player-go-back"
          >
            <img src="/images/arrow-left-white.svg" alt="" />
            RETOUR
          </router-link>
          <a
            v-else
            @click.prevent="$root.playerInfoOpen = false"
            class="player-go-back"
          >
            <img src="/images/arrow-left-white.svg" alt="" />
            RETOUR
          </a>
        </li>
      </ul>

      <!-- News submenu navigation for mobile -->
      <ul v-else-if="section.type == 'news'">
        <li
          v-for="list in section.children"
          v-if="list.slug == $route.params.subsectionSlug"
          :key="list.id"
        >
          <a @click.prevent="subsectionsOpen = !subsectionsOpen">
            {{ list.title }}
            <img
              class="cross"
              :class="{ 'cross--active': subsectionsOpen }"
              src="/images/plus.svg"
              alt="more"
            />
          </a>
        </li>

        <li v-for="year in newsYears" v-if="subsectionsOpen" :key="year">
          <a @click.prevent="goToNewsYear(year)">
            {{ year }}
          </a>
        </li>
      </ul>

      <ul v-else-if="section.type == 'teams'" class="fi">
        <li v-if="$root.documentsOpen">
          <a
            @click.prevent="$root.documentsOpen = false"
            class="player-go-back"
          >
            <img src="/images/arrow-left-white.svg" alt="" />
            RETOUR
          </a>
        </li>
        <li
          v-for="team in teams"
          :key="team.id"
          v-if="team.show_on_nav == 1 && team.slug == $route.params.pageSlug"
        >
          <a @click.prevent="teamsNavOpen = !teamsNavOpen">
            {{ team.name }}
            <img
              class="d-sm-none cross"
              :class="{ 'cross--active': teamsNavOpen }"
              src="/images/plus.svg"
              alt="more"
            />
          </a>
        </li>

        <li
          v-for="teamCategory in teamsWithCategories"
          :key="teamCategory.id"
          v-if="
            !$route.params.pageSlug &&
              teamCategory.slug == $route.params.subsectionSlug
          "
        >
          <a @click.prevent="teamsNavOpen = !teamsNavOpen">
            {{ teamCategory.name }}
            <img
              class="d-sm-none cross"
              :class="{ 'cross--active': teamsNavOpen }"
              src="/images/plus.svg"
              alt="more"
            />
          </a>
        </li>

        <template v-if="teamsNavOpen">
          <li
            v-for="team in teams"
            class="gsap-fade"
            v-if="team.slug !== $route.params.pageSlug && team.show_on_nav == 1"
            :key="team.id"
          >
            <router-link
              :to="{
                name: 'page',
                params: {
                  sectionSlug: section.slug,
                  subsectionSlug: actifs.slug,
                  pageSlug: team.slug,
                },
              }"
            >
              {{ team.name }}
            </router-link>
          </li>

          <li
            v-for="teamCategory in teamsWithCategories"
            class="gsap-fade"
            :key="teamCategory.id"
            v-if="
              teamCategory.type == 'actifs' ||
                teamCategory.type == 'juniors' ||
                teamCategory.type == 'futsal' ||
                teamCategory.type == 'females' ||
                teamCategory.slug !== $route.params.subsectionSlug
            "
          >
            <router-link
              :to="{
                name: 'SubSection',
                params: {
                  sectionSlug: section.slug,
                  subsectionSlug: teamCategory.slug,
                },
              }"
            >
              {{ teamCategory.name }}
            </router-link>
          </li>
        </template>
      </ul>

      <ul v-else>
        <li
          v-for="list in section.children"
          v-if="list.slug == $route.params.subsectionSlug"
          :key="list.id"
        >
          <a @click.prevent="subsectionsOpen = !subsectionsOpen">
            {{ list.title }}
            <img
              class="cross"
              :class="{ 'cross--active': subsectionsOpen }"
              src="/images/plus.svg"
              alt="more"
            />
          </a>
        </li>
        <li
          v-for="list in section.children"
          v-if="subsectionsOpen && list.slug != $route.params.subsectionSlug"
          :key="list.id"
        >
          <router-link
            :to="{
              name: 'SubSection',
              params: { sectionSlug: section.slug, subsectionSlug: list.slug },
            }"
          >
            <img
              class="lfc-logo"
              src="/images/lfc-logo.svg"
              v-if="list.type == 'sponsors' || list.type == 'raiffeisen_lfc'"
              alt="Lancy LFC Logo"
            />
            {{ list.title }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _find from "lodash/find";
import _map from "lodash/map";
import _findIndex from "lodash/findIndex";
import { mapState } from "vuex";

export default {
  props: ["propSections"],
  data() {
    return {
      submenu: null,
      teamsNavOpen: false,
      menu: false,
      selectedList: null,
      subsectionsOpen: false,
      playerInfoOpen: false,
      juniorsLastSubCategory: false,
    };
  },
  watch: {
    menu: function(val) {
      if (val) {
        $("body").addClass("no-overflow");
      } else {
        this.selectedList = null;
        this.submenu = this.section;
        $("body").removeClass("no-overflow");
      }
    },
    $route: function() {
      this.menu = false;
      this.selectedList = null;
      this.submenu = null;
      this.subsectionsOpen = false;
      this.teamsNavOpen = false;
      $("body").removeClass("no-overflow");
    },
    "$root.playerInfoOpen": function(val) {
      if (val) {
        this.playerInfoOpen = true;
      } else {
        this.playerInfoOpen = false;
      }
    },
    "$root.juniorsSubCategory": function(val) {
      if (val) {
        this.juniorsLastSubCategory = true;
      } else {
        this.juniorsLastSubCategory = false;
      }
    },
  },
  mounted() {
    this.sections = this.propSections;
    this.submenu = this.section;
    let media = _find(this.sections, { type: "media" });
    let documentPage = _find(media.children, { type: "documents" });
    let idx = _findIndex(this.sections, { type: "media" });
    this.sections.splice(idx, 0, documentPage);
    this.sections = _map(this.sections, (s, i) => {
      s.index = i;
      return s;
    });
  },
  methods: {
    getSubmenu(section, index) {
      this.submenu = section;
      if (this.selectedList == index) {
        this.selectedList = null;
      } else {
        this.selectedList = index;
      }
      this.$nextTick(() => {
        this.fade(".gsap-fade");
      });
    },
    scrollTop() {
      window.scroll(0, 0);
    },
    goToNewsYear(year) {
      this.subsectionsOpen = false;
      $("html, body").animate(
        {
          scrollTop: $(`#${year}`).offset().top - 150,
        },
        500
      );
    },
    goToTeam(team) {
      if (team.category_id) {
        this.teamsWithCategories.forEach((teamCategory) => {
          if (team.category_id == teamCategory.id) {
            this.$router.push({
              name: "page",
              params: {
                sectionSlug: this.teamsSection.slug,
                subsectionSlug: teamCategory.slug,
                pageSlug: team.slug,
              },
            });
          }
        });
      }
    },
    // Animations
    fade(el) {
      TweenMax.staggerFromTo(el, 0.3, { opacity: 0 }, { opacity: 1 }, 0.1);
    },
    navItems(items) {
      let excluded = ["footer", "home", "socials"];

      return items.filter((s) => !excluded.includes(s.type));
    },
  },
  computed: {
    home() {
      return _find(this.allSections, { type: "home" });
    },
    socials() {
      return _find(this.allSections, { type: "socials" });
    },
    section() {
      return _find(this.allSections, { slug: this.$route.params.sectionSlug });
    },
    team() {
      return _find(this.teams, { slug: this.$route.params.pageSlug });
    },
    actifs() {
      return _find(this.teamsWithCategories, { type: "actifs" });
    },
    females() {
      return _find(this.allSections, { type: "féminines" });
    },
    teamsSection() {
      return _find(this.allSections, { type: "teams" });
    },
    ...mapState(["allSections", "teams", "newsYears", "teamsWithCategories"]),
  },
};
</script>
